import { render, staticRenderFns } from "./module4.vue?vue&type=template&id=e28d1188&scoped=true"
import script from "./module4.vue?vue&type=script&lang=js"
export * from "./module4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28d1188",
  null
  
)

export default component.exports